import dayjs from 'dayjs';

export default (timestamp, timezone) =>
  dayjs.unix(timestamp).tz(timezone).unix();
